import React from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { PublicHeader } from './PublicHeader';
import { SiteCopyrightBar } from '../SiteCopyrightBar';
import { PreFooterCta } from '../PreFooterCta';

export const PublicLayout: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: '#eaeded',
      }}
    >
      <PublicHeader />
      <Box component="main" sx={{ flex: 1 }}>
        <Outlet />
      </Box>
      <PreFooterCta />
      <SiteCopyrightBar />
    </Box>
  );
};
